var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"programsView main_view"},[_c('header-comp'),_c('div',{staticClass:"view_grid"},[_c('navbar-comp',{staticClass:"navbar",attrs:{"active":'programs'}}),(_vm.show == 'all')?_c('programs-comp'):_vm._e(),(_vm.show == 'one')?_c('program-comp'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }